import { ERROR_CODES } from "./Utils";

/**
 * Custom error class for handling printer-related errors.
 */
class PrinterError extends Error {
    /**
     * Creates a new PrinterError instance.
     *
     * @param {Object} errorCode - The error code object from ERROR_CODES.
     * @param {string|null} [customMessage] - Optional custom error message.
     * @param {any} [details] - Additional details about the error (optional).
     */
    constructor(errorCode = ERROR_CODES.UNKNOWN, customMessage = null, details = null) {
        const message = customMessage || errorCode.message; // Use custom message if provided
        super(message); // Call the parent Error constructor
        this.name = errorCode.name || "PrinterError"; // Set the error name
        this.code = errorCode.code; // HTTP status code
        this.details = details; // Additional context or metadata
    }

    /**
     * Serializes the PrinterError into a structured object for logging or responses.
     *
     * @returns {Object} - Serialized error object.
     */
    serialize() {
        return {
            name: this.name,
            code: this.code,
            message: this.message,
            details: this.details,
        };
    }
}

export default PrinterError;
